import React from "react";


const posts = [
  {
    id: 1,
    title: 'Tout savoir sur le compromis de vente chez le notaire',
    href: 'https://clotere.fr/immobilier/notaire/compromis-de-vente',
    description:"Découvrez toutes les étapes du compromis de vente : rôle du notaire, délais, documents à fournir et frais à anticiper.",
     imageUrl:
      'https://framerusercontent.com/images/lHsL1irKXdYo9KEuVBCNMORnM.jpg',
    category: { title: 'Compromis de vente', href: '#' },
  },
  {
    id: 2,
    title: 'Comment choisir son notaire ?',
    href: "https://clotere.fr/immobilier/notaire/comment-choisir-son-notaire",
    description:"Tout ce que vous devez savoir pour choisir votre notaire",
     imageUrl:
      'https://framerusercontent.com/images/7qUTqENEJz4uogCoIgtjNUWQA.webp',
    category: { title: 'Rendez-vous notaire', href: '#' },
  },
  {
    id: 3,
    title: 'Pourquoi faire un contrat de mariage chez le notaire, on vous dit tout',
    href: 'https://clotere.fr/contrat-mariage/notaire/pourquoi-faire-un-contrat-de-mariage',
    description:"Faire un contrat de mariage chez le notaire vous offre des garanties juridiques solides. Voici pourquoi c’est une bonne idée.",
     imageUrl:
      'https://images.unsplash.com/photo-1500771967326-9b2f6200d1c6?q=80&w=3270&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    category: { title: 'Comment choisir son notaire pour son achat immobilier ?', href: '#' },
  },

]

function NotaireEnClair(args) {

  return (
    <div className="bg-white">
    <div className="py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-black leading-[28px] !text-[30px] lg:leading-[30px] lg:text-[45px] font-bold mt-10 sm:mt-0">
            Le notaire en clair !
          </p>
          <p className="mt-2 text-lg leading-8 text-gray-600 font-medium">
            Améliorer le passage chez le notaire ça passe aussi et surtout par l'explication !
            <span className="hidden sm:block">Notre blog vous guide dans vos démarches chez le notaire 👇</span>
          </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {posts.map((post) => (
            <article
              key={post.id}
              className="relative isolate flex flex-col justify-end overflow-hidden rounded-2xl bg-gray-900 px-8 pb-8 pt-80 sm:pt-48 lg:pt-80"
            >
              <img alt="" src={post.imageUrl} className="absolute inset-0 -z-10 h-full w-full object-cover" />
              <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40" />
              <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10" />

              <div className="flex flex-wrap items-center gap-y-1 overflow-hidden text-sm leading-6 text-gray-300">
                
                <div className="-ml-4 flex items-center gap-x-4">
                  <svg viewBox="0 0 2 2" className="-ml-0.5 h-0.5 w-0.5 flex-none fill-white/50">
                    <circle r={1} cx={1} cy={1} />
                  </svg>
                  <div className="flex gap-x-2.5">
                    <img alt="" src="http://localhost:3000/static/media/icn-logo.7a16ec775e6f041426f1a66d292f908b.svg" className="h-6 w-6 flex-none rounded-full bg-white/10" />
                    Clotere
                  </div>
                </div>
              </div>
              <h3 className="mt-3 text-lg font-semibold leading-6 text-white">
                <a href={post.href}  target="blank" className="text-white no-underline">
                  <span className="absolute inset-0" />
                  {post.title}
                </a>
              </h3>
            </article>
          ))}
        </div>
      </div>
      <div className="flex justify-center mt-5">
        <a href="https://clotere.fr/blog" target="blank" className="btn-primary no-underline">Lire notre blog</a>
      </div>
    </div>
    
    </div>
  );
}

export default NotaireEnClair;